/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { SequenceFeature } from "./SequenceFeature";
import { SequenceFeatureFromJSON, SequenceFeatureFromJSONTyped, SequenceFeatureToJSON } from "./SequenceFeature";
import type { SequenceType } from "./SequenceType";
import { SequenceTypeFromJSON, SequenceTypeFromJSONTyped, SequenceTypeToJSON } from "./SequenceType";

/**
 * An Entity containing a sequence, such as a TPP, a Vector or an AntibodyClone
 * @export
 * @interface EntitySequence
 */
export interface EntitySequence {
  /**
   *
   * @type {string}
   * @memberof EntitySequence
   */
  entityQualifiedId?: string;
  /**
   *
   * @type {string}
   * @memberof EntitySequence
   */
  entityLabel?: string;
  /**
   *
   * @type {string}
   * @memberof EntitySequence
   */
  entityDescription?: string;
  /**
   *
   * @type {string}
   * @memberof EntitySequence
   */
  entityUrl?: string;
  /**
   *
   * @type {string}
   * @memberof EntitySequence
   */
  entityClassLabelSingular?: string;
  /**
   *
   * @type {string}
   * @memberof EntitySequence
   */
  entityClassLabelPlural?: string;
  /**
   *
   * @type {string}
   * @memberof EntitySequence
   */
  chainInfoLabel?: string;
  /**
   *
   * @type {number}
   * @memberof EntitySequence
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof EntitySequence
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EntitySequence
   */
  qualifiedId: string;
  /**
   *
   * @type {string}
   * @memberof EntitySequence
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof EntitySequence
   */
  synonym?: string;
  /**
   *
   * @type {string}
   * @memberof EntitySequence
   */
  chainInfoKey?: string;
  /**
   *
   * @type {SequenceType}
   * @memberof EntitySequence
   */
  sequenceType: SequenceType;
  /**
   *
   * @type {boolean}
   * @memberof EntitySequence
   */
  circular?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EntitySequence
   */
  directStrand?: boolean;
  /**
   *
   * @type {string}
   * @memberof EntitySequence
   */
  residues: string;
  /**
   *
   * @type {Array<SequenceFeature>}
   * @memberof EntitySequence
   */
  features: Array<SequenceFeature>;

  genomeName: string;
  database: string;
}

/**
 * Check if a given object implements the EntitySequence interface.
 */
export function instanceOfEntitySequence(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "qualifiedId" in value;
  isInstance = isInstance && "sequenceType" in value;
  isInstance = isInstance && "residues" in value;
  isInstance = isInstance && "features" in value;

  return isInstance;
}

export function EntitySequenceFromJSON(json: any): EntitySequence {
  return EntitySequenceFromJSONTyped(json, false);
}

export function EntitySequenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntitySequence {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    entityQualifiedId: !exists(json, "entityQualifiedId") ? undefined : json["entityQualifiedId"],
    entityLabel: !exists(json, "entityLabel") ? undefined : json["entityLabel"],
    entityDescription: !exists(json, "entityDescription") ? undefined : json["entityDescription"],
    entityUrl: !exists(json, "entityUrl") ? undefined : json["entityUrl"],
    entityClassLabelSingular: !exists(json, "entityClassLabelSingular") ? undefined : json["entityClassLabelSingular"],
    entityClassLabelPlural: !exists(json, "entityClassLabelPlural") ? undefined : json["entityClassLabelPlural"],
    chainInfoLabel: !exists(json, "chainInfoLabel") ? undefined : json["chainInfoLabel"],
    id: json["id"],
    name: json["name"],
    genomeName: json["genomeName"],
    database: json["database"],
    qualifiedId: json["qualifiedId"],
    description: !exists(json, "description") ? undefined : json["description"],
    synonym: !exists(json, "synonym") ? undefined : json["synonym"],
    chainInfoKey: !exists(json, "chainInfoKey") ? undefined : json["chainInfoKey"],
    sequenceType: SequenceTypeFromJSON(json["sequenceType"]),
    circular: !exists(json, "circular") ? undefined : json["circular"],
    directStrand: !exists(json, "directStrand") ? undefined : json["directStrand"],
    residues: json["residues"],
    features: (json["features"] as Array<any>).map(SequenceFeatureFromJSON),
  };
}

export function EntitySequenceToJSON(value?: EntitySequence | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    entityQualifiedId: value.entityQualifiedId,
    entityLabel: value.entityLabel,
    entityDescription: value.entityDescription,
    entityUrl: value.entityUrl,
    entityClassLabelSingular: value.entityClassLabelSingular,
    entityClassLabelPlural: value.entityClassLabelPlural,
    chainInfoLabel: value.chainInfoLabel,
    id: value.id,
    name: value.name,
    qualifiedId: value.qualifiedId,
    description: value.description,
    synonym: value.synonym,
    chainInfoKey: value.chainInfoKey,
    sequenceType: SequenceTypeToJSON(value.sequenceType),
    circular: value.circular,
    directStrand: value.directStrand,
    residues: value.residues,
    features: (value.features as Array<any>)?.map(SequenceFeatureToJSON),
  };
}
